var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGnComplianceTriggerStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 8.5,
    fill: "white",
    stroke: "#74C0FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19H22M10 17L7.5 20L6 19M13 14H22M10 12L7.5 15L6 14M13 9H22M10 7L7.5 10L6 9",
    stroke: "#74C0FC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGnComplianceTriggerStatus);
export default __webpack_public_path__ + "static/media/gn-compliance-trigger-status.c86e616bcda9af97e23ac536f6408a56.svg";
export { ForwardRef as ReactComponent };